import React, {useEffect, useState} from 'react';
import AssetListListType from "./subPages/list/AssetListListType";
import {isMobile, toKSTISOString, toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import {PageHeader} from "../../../../components/PageHeader";
import AssetListThumbType from "./subPages/list/AssetListThumbType";
import {useDispatch} from "react-redux";
import useRequestData from "../../../../hooks/useRequestData";
import {getAssetsMybatis} from "../../../../api/asset/AssetService";
import {addYears} from "date-fns";
import MobileCreateButton from "../../../../components/buttons/MobileCreateButton";
import {useMobileViewport} from "../../../../hooks/useMobileViewport";

function AssetList() {
    const [listType, setListType] = useState(true)
    const [checked,setChecked] = useState([]);
    const dp = useDispatch();
    const isMobileViewport = useMobileViewport();

    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }
    useEffect(() => {
        if (isMobile) {
            setListType(false);
        }
    }, []);

    const { data, newData, pageInfo, refresh, dataHook, getQr } = useRequestData(getAssetsMybatis, initDate, 'asset');
    const useListLayout = listType || isMobile || isMobileViewport;

    return (
        <>
            <div className="common-container">
                <PageHeader header={"자산정보관리"} indicator={"자산관리 > 자산종합관리 > 자산정보관리"}/>

                {useListLayout ? (
                    <AssetListListType
                        data={newData}
                        date={initDate}
                        pageInfo={pageInfo}
                        dataHook={dataHook}
                        getQr={getQr}
                        checked={{checked: checked, setChecked: setChecked}}
                    />
                ) : (
                    <AssetListThumbType
                        data={data}
                        date={initDate}
                        pageInfo={pageInfo}
                        dataHook={dataHook}
                    />
                )}
                <MobileCreateButton url={'/asset/create'} assetCheck/>
            </div>
        </>
    );
}

export default AssetList;